import { Icon, Typography } from "minimum-ui/core";
import { color } from "minimum-ui/tokens/colors";
import { Trans } from "react-i18next";

import { Group, Namespace } from "./model";
import { getId } from "./useTranslate";

interface Props {
  i18nKey: string;
  group?: Group;
  namespace?: Namespace;
  components?: Record<string, React.ReactElement>;
  placeholders?: Record<string, string | number>;
  color?: string;
}

const getTypographyComponents = (
  textColor?: string
): Record<string, React.ReactElement> => ({
  display: <Typography variant="display" color={textColor} />,
  titleLarge: <Typography variant="titleLarge" color={textColor} />,
  titleMedium: <Typography variant="titleMedium" color={textColor} />,
  titleSmall: <Typography variant="titleSmall" color={textColor} />,
  subTitle: <Typography variant="subTitle" color={textColor} />,
  bodyLarge: <Typography variant="bodyLarge" color={textColor} />,
  bodyMedium: <Typography variant="bodyMedium" color={textColor} />,
  bodySmall: <Typography variant="bodySmall" color={textColor} />,
  fieldTitle: <Typography variant="fieldTitle" color={textColor} />,
});

const iconComponents: Record<string, React.ReactElement> = {
  infoIcon: <Icon icon="circleInfo" color={color.blue[300]} size="lg" />,
  successIcon: <Icon icon="circleCheck" color={color.green[300]} size="lg" />,
  warnIcon: (
    <Icon icon="triangleExclamation" color={color.yellow[300]} size="lg" />
  ),
  errorIcon: <Icon icon="circleXmark" color={color.red[400]} size="lg" />,
};

const htmlComponents: Record<string, React.ReactElement> = {
  u: <u />,
  i: <i />,
  b: <b />,
  strong: <strong />,
  li: <li />,
  ul: <ul />,
};

export const Translate = ({
  i18nKey,
  group = Group.DEFAULT,
  namespace = Namespace.DEFAULT,
  components,
  placeholders,
  color: textColor,
}: Props) => {
  const i18nKeyWithNamespace = getId(i18nKey, group, namespace);

  return (
    <Trans
      i18nKey={i18nKeyWithNamespace}
      components={{
        ...getTypographyComponents(textColor),
        ...htmlComponents,
        ...iconComponents,
        ...components,
      }}
      values={placeholders}
    />
  );
};
